export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6482.ccd6f797.jpg";